import React from 'react';
import './Cloud.css'; // Import the CSS file for styling

const CloudComponent = () => {
  return (
    <div className="cloud">
      <div className="circle big"></div>
      <div className="circle medium"></div>
      <div className="circle small"></div>
    </div>
  );
};

export default CloudComponent;
